import axios from "axios";
import { baseUrl } from "../helpers/baseUrl";

export async function getAvailableReward(username) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/reward/totalreward/${username}`
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getAllRewardsEarned(username) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(`${baseUrl}/reward/getreward/${username}`);
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getRewardsLike(username, pageNumber) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/reward/getlikerward/${username}/?pageNumber=${pageNumber}`
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getRewardsComment(username, pageNumber) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/reward/getcommentdetails/${username}/?pageNumber=${pageNumber}`
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getRewardsPosts(username, pageNumber) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/reward/getpostdetails/${username}/?pageNumber=${pageNumber}`
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getRewardsNft(username, pageNumber) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/reward/getnftdetails/${username}/?pageNumber=${pageNumber}`
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getRewardsEvent(username, pageNumber) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/reward/geteventdetails/${username}/?pageNumber=${pageNumber}`
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getRewardsEngagement(username, pageNumber) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/reward/geteengagement/${username}/?pageNumber=${pageNumber}`
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function getRewardsClaimHistory(pageNumber) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/reward/getclaims/?pageNumber=${pageNumber}`
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function claimReward(claimAmount) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(
      `${baseUrl}/reward/claimreward`,
      claimAmount
    );
    return response;
  } catch (err) {
    console.log("err", err);
    return err;
  }
}

export async function claimOtp(otpData) {
  let tokenStr = localStorage.getItem("jwtTokenSingh");
  axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(
      `${baseUrl}/reward/validate-otp`,
      otpData
    );
    return response;
  } catch (err) {
    console.log("err", err);
    // return err;
    return "Something went wrong, Please try again later";
  }
}
